import { useQuery } from '@apollo/client';
import { useTranslation } from '@eti/providers';
import { Stack, Text } from '@etg/wings';
import { CHECKIN_STATUS_QUERY } from '../../../containers/queries';
import ErrorPage from '../../../../status-pages/components/ErrorPage';
import Loading from '../../../../../common/loading/components/Loading';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import TitledCard from '../../../../../common/components/TitledCard';
import { getTripSegmentsFromBounds } from '../../../utils';
import SegmentCheckInInfo from './SegmentCheckInInfo';

const PurchasedCheckIn = () => {
  const { t } = useTranslation();
  const { bounds, travelers } = useOrderDetails();

  const { loading, data, error } = useQuery(CHECKIN_STATUS_QUERY, {
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return <Loading />;
  }

  if (error || !data?.checkInStatus) {
    return <ErrorPage />;
  }

  const { checkInStatus } = data;

  return (
    <TitledCard title={t('CheckIn.Purchased.Title')}>
      <Stack spacing={24}>
        <Stack data-testid="purchased-checkin" spacing={8}>
          <Text asHtml>{t('CheckIn.Purchased.Description')}</Text>
        </Stack>
        <Stack role="list">
          {getTripSegmentsFromBounds(bounds).map((segment, index) => (
            <SegmentCheckInInfo
              checkInStatus={checkInStatus}
              dataTestId={`segment-check-in-info-${index}`}
              key={index}
              segment={segment}
              travelers={travelers}
            />
          ))}
        </Stack>
      </Stack>
    </TitledCard>
  );
};

export default PurchasedCheckIn;
